import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header'
import UserMenu from '../components/userMenu'
import * as depositWithdrawalService from '../services/depositWithdrawalService';
// import Toast from './sub_components/toast'
// import * as dateUtil from '../util/date.util'
// import Currency from './sub_components/currency'
// import printJS from 'print-js'
class withdrawal extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            userId:'',
            bankName: "",
            accountHolderName: "",
            accountNumber: "",
            iFSCCode: "",
            amount: 0,
            balance: 0,
            emailId:'',
            mobileNumber:'',
            paymentMode: "Bank",
            upiType: "Gpay",
            walletName: "",
            walletNumber: "",
            operatorId: ''
        }; 
    }
    componentDidMount() {
        this.getBalance()
    }
    getBalance(){
        let userData = localStorage.getItem('profData')
        if(!!userData){
         userData = JSON.parse(userData)
         let bal = parseFloat(userData.availableBalance);
         if(!!userData.exposure){
            bal = bal + parseFloat(userData.exposure)
         }
         if(!!userData.upLineBalance){
            bal = bal + parseFloat(userData.upLineBalance)
         }
         this.setState({userId: userData.username, emailId: userData.email, mobileNumber: userData.mobile, balance: bal.toFixed(2), operatorId: userData.operatorId})
        }
    }
    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    }

    onRadioChange(e){
        debugger
    }

    validateWithdrawalForm(){
        let returnval = true;
        if(this.state.paymentMode === "Bank"){
            returnval = !!this.state.accountHolderName && this.state.accountHolderName.length > 1 && !!this.state.accountNumber && this.state.accountNumber.length > 4 && !!this.state.iFSCCode && this.state.iFSCCode.length > 9 && !!this.state.amount && parseFloat(this.state.amount) <= parseFloat(this.state.balance) ? false : true;
        } else {
            returnval = !!this.state.upiType && !!this.state.walletName && this.state.walletName.length > 1 && !!this.state.walletNumber && this.state.walletNumber.length > 9 && !!this.state.amount && parseFloat(this.state.amount) <= parseFloat(this.state.balance) ? false : true;
        }
        return returnval
    }    
    onWithdrawalClick(){
        const self = this
        let body={
            "operatorId" : this.state.operatorId,
            "username" : this.state.userId,
            "amount" : this.state.amount,
            "paymentMode" : this.state.paymentMode,
            "accountName" : this.state.paymentMode === "Bank" ? this.state.accountHolderName : this.state.walletName,
            "accountNumber" : this.state.paymentMode === "Bank" ? this.state.accountNumber : this.state.walletNumber,
            "routingInformation" : this.state.paymentMode === "Bank" ? this.state.iFSCCode : this.state.upiType,
        }
        // "email" : this.state.emailId,
        // "mobile" : this.state.mobileNumber,
        
        depositWithdrawalService.withdrawalOrder(body).then((res) => {
            if (!!res) {
                self.props.notify(`Withdraw Request Placed Successfully. withdrawId: ${res.withdrawId}`, "success")
                self.setState({
                    bankName: "",
                    accountHolderName: "",
                    accountNumber: "",
                    iFSCCode: "",
                    balance: parseFloat(self.state.balance) - self.state.amount,
                    amount: "",
                    upiType: "Gpay",
                    walletName: "",
                    walletNumber: "",
                },()=>{
                    window.location.reload()
                })
            }
        })
    }
    render() {
        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) =>this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id)=>{this.props.subscribe(type, id)}} subscriptions={this.props.subscriptions} history = {this.props.history} socket={this.props.socket}/>
                <div className="full-wrap">
                    <UserMenu history={this.props.history} isMaintanance={this.state.isMaintanance} />
                    <div className="col-center1 markets">
                        <div className='mar-top100'>
                            <div className="sub_path center-box mt-2"><p>Withdrawal Form</p></div>
                            <div className='allreport col3'>
                                <div className='d-flex'>
                                    <div className='payment-methods__detail-form withdrawal__detail-form'>
                                        <div className='form-group'>
                                            <label className='form--title mr-2'>Payment Mode</label>
                                            <span className='mr-3'><input className='mr-1' id="UPIRadio" type='radio' name='paymentMode' value={"UPI"} checked={this.state.paymentMode === "UPI"} onClick={(e) => this.onChange(e)}/>UPI</span>
                                            <span><input className='mr-1' id="BankRadio" type='radio' name='paymentMode' value={"Bank"} checked={this.state.paymentMode === "Bank"} onClick={(e) => this.onChange(e)}/>Bank</span>
                                        </div>
                                        {this.state.paymentMode === "Bank" &&
                                            <>
                                                {/* <div className='form-group'>
                                                    <label className='form--title'>Bank Name</label>
                                                    <input id='bankName' className='form-control text-capitalize' name='bankName' type='text' value={this.state.bankName} onChange={(e) => this.onChange(e)}></input>
                                                </div> */}
                                                <div className='form-group'>
                                                    <label className='form--title'>Account Holder Name</label>
                                                    <input id='accountHolderName' className='form-control text-capitalize' name='accountHolderName' type='text' value={this.state.accountHolderName} onChange={(e) => this.onChange(e)}></input>
                                                </div>
                                                <div className='form-group'>
                                                    <label className='form--title'>Account Number</label>
                                                    <input id='accountNumber' className='form-control' name='accountNumber' type='number' value={this.state.accountNumber} onChange={(e) => this.onChange(e)}></input>
                                                </div>
                                                <div className='form-group'>
                                                    <label className='form--title'>IFSC Code</label>
                                                    <input id='iFSCCode' className='form-control text-uppercase' name='iFSCCode' type='text' value={this.state.iFSCCode} onChange={(e) => this.onChange(e)}></input>
                                                </div>
                                            </>
                                        }
                                        {this.state.paymentMode === "UPI" &&
                                            <>
                                                <div className='form-group'>
                                                    <label className='form--title'>Select UPI</label>
                                                    <select className="form-control" name="upiType" onChange={(e) => this.onChange(e)} value={this.state.upiType}>
                                                        <option value="Gpay">Gpay</option>
                                                        <option value="Phonepe">Phonepe</option>
                                                        <option value="Paytm">Paytm</option>
                                                        <option value="Bhim">Bhim</option>
                                                        <option value="Bharatpe">Bharatpe</option>
                                                    </select>
                                                </div>
                                                <div className='form-group'>
                                                    <label className='form--title'>Wallet Name</label>
                                                    <input id='walletName' className='form-control text-capitalize' name='walletName' type='text' value={this.state.walletName} onChange={(e) => this.onChange(e)}></input>
                                                </div>
                                                <div className='form-group'>
                                                    <label className='form--title'>Wallet Number</label>
                                                    <input id='walletNumber' className='form-control' name='walletNumber' type='number' maxLength={15} value={this.state.walletNumber} onChange={(e) => this.onChange(e)}></input>
                                                </div>
                                            </>
                                        }
                                        <div className='form-group'>
                                            <label className='form--title'>Amount</label>
                                            {/* <label className='float-right'><small>Current Balance:</small> <b>{this.state.balance}</b></label> */}
                                            <input id='amount' className='form-control' name='amount' type='number' value={this.state.amount} onChange={(e) => this.onChange(e)}></input>
                                            {!!this.state.amount && (parseFloat(this.state.amount) > parseFloat(this.state.balance) ? <label className='signup-validation-text' style={{ color: "red" }}>Withdrawal amount cannot be greater the balance.</label> : null)}
                                        </div>
                                        <div className='form-group'>
                                            <button className='btn-type-submit' disabled={this.validateWithdrawalForm()} onClick={()=>this.onWithdrawalClick()}>Withdraw</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withdrawal);